<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><i>When someone shows you who they are, believe them the first time. People know themselves much better than you do. That’s why it’s important to stop expecting them to be something other than who they are.</i> — <b><i>Maya Angelou</i></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5bb2ee59